export default __webpack_public_path__ + "static/media/grid.006.6bf14689.jpeg";